<template>
  <div class="standardization-notification-wrapper">
    <div
      class="flex flex1 justify-between item-center button-title__box"
    >
      <div class="flex justify-start">
        <GreenButton
          class="button__default"
          text="填报"
          @click="createChange"
        ></GreenButton>
      </div>
    </div>
    <el-table
      :data="projectData"
      :header-cell-style="{background: 'rgba(0,0,0,0.02)',borderTop:'1px solid rgba(0,0,0,0.1)'}"
      :loading="projectLoading"
      class="table-box"
      height="calc(100% - 165px)"
    >
      <el-table-column
        label="附件"
      >
        <template #default="scope">
          <div
            class="file-download pointer"
            @click="downloadFileChange(scope.row)"
          >{{ scope.row['Name'] }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="创建时间"
        prop="CreationDate"
        width="160"
      >
        <template #default="scope">
          <span>{{ scope.row['CreationDate'] | timeDateFilter }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="创建人"
        prop="CreationUser"
        width="200"
      ></el-table-column>
      <el-table-column
        label="操作"
        width="120"
      >
        <template #default="scope">
          <el-link
            type="primary"
            @click="deleteInfo(scope.row)"
          >
            删除
          </el-link>
        </template>
      </el-table-column>
    </el-table>
    <div
      class="table-box__pagination flex flex1 justify-end items-center"
    >
      <el-pagination
        :current-page.sync="pageIndex"
        :page-size.sync="pageSize"
        :total="allTotal"
        layout="total, prev, pager, next"
        @current-change="onPageIndexChange"
      ></el-pagination>
    </div>
    <CreateStandardizationDialog
      :id="currentID"
      :is-edit="isCreateEdit"
      :visible="createDialogVisible"
      @closeDialog="onImportDialogClose()"
      @refresh="onRefreshDialogClose()"
    ></CreateStandardizationDialog>
    <el-image-viewer
      v-if="isShowImage"
      :on-close="
          () => {
            isShowImage = false
          }
        "
      :url-list="srcList"
    ></el-image-viewer>
  </div>
</template>
<script>
import GreenButton from '@/components/buttons/GreenButton'
import CreateStandardizationDialog from '@/components/dialog/CreateStandardizationDialog'

export default {
  name: 'standardizationNotification',
  components: {
    GreenButton,
    CreateStandardizationDialog
  },
  filters: {
    timeDateFilter(date) {
      return typeof date === 'string' ? date.split('T')[0] : ''
    }
  },
  data() {
    return {
      pageIndex: 1,
      pageSize: 11,
      allTotal: 0,
      projectLoading: false,
      projectData: [],
      createDialogVisible: false,
      isCreateEdit: false,
      currentID: -1,
      isShowImage: false,
      srcList: []
    }
  },
  mounted() {
    this.getProjectInfo()
  },
  destroy() {
  },
  methods: {
    /**
     * 获取 施工标准化过程检查通报 数据
     * */
    async getProjectInfo() {
      this.projectLoading = true
      const { success, data } = await this.$http({
        url: this.$api.getPageQueryNotificationFile,
        params: {
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
        }
      })
      if (success) {
        const { rows, total } = data
        if (data.hasOwnProperty('rows')) {
          this.projectData = [...rows]
          if (data.hasOwnProperty('total')) {
            this.allTotal = total
          }
        }
      }
      this.projectLoading = false
    },
    /**
     * 切换分页
     * */
    onPageIndexChange(pageIndex) {
      this.pageIndex = pageIndex
      this.getProjectInfo()
    },
    /**
     * 填报 选择
     * */
    createChange() {
      this.createDialogVisible = true
    },
    /**
     * 填报 关闭dialog回调
     * */
    onImportDialogClose() {
      this.isCreateEdit = false
      this.createDialogVisible = false
    },
    /**
     * 填报 刷新dialog回调
     * */
    onRefreshDialogClose() {
      this.isCreateEdit = false
      this.createDialogVisible = false
      this.pageIndex = 1
      this.getProjectInfo()
    },
    /**
     * 编辑信息
     * */
    editInfo(item) {
      const { ID } = item
      this.currentID = ID
      this.isCreateEdit = true
      this.createDialogVisible = true
    },
    /**
     * 删除信息
     * */
    deleteInfo(item) {
      const { ID } = item
      this.$confirm('是否确认删除', '删除施工标准化过程检查通报', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true
            instance.confirmButtonText = '删除中...'
            setTimeout(async () => {
              await this.deleteChange(ID)
              done()
              setTimeout(() => {
                instance.confirmButtonLoading = false
              }, 300)
            }, 300)
          }
          else {
            done()
          }
        }
      })
    },
    /**
     * 确认删除
     * */
    async deleteChange(ID) {
      const { success } = await this.$http({
        url: this.$api.goDeleteNotificationFile,
        params: {
          id: ID
        }
      })
      if (success) {
        this.$message.success('删除成功')
        this.pageIndex = 1
        await this.getProjectInfo()
      }
    },
    /**
     * 下载文件
     * */
    downloadFileChange(item) {
      const { RemotePath, Name, Suffix } = item
      const imageCategory = ['.png', '.jpg', '.jpeg', '.svg', '.gif']
      if (RemotePath !== '') {
        this.srcList = []
        if (imageCategory.includes(Suffix)) {
          this.isShowImage = true
          const newUrl = `${WEB_CONFIG.BASE_URL}${RemotePath}`
          this.srcList.push(newUrl)
        }
        else {
          this.$downloadFileChange(RemotePath)
        }
      }
      else {
        this.$message.error('下载失败')
      }
    }
  }
}
</script>
<style scoped>
.standardization-notification-wrapper {
  height: 100%
}

::v-deep .el-link.el-link--primary {
  color: #005BAC;
}
</style>
